<template>
  <div class="app-drop-add-modal t-modal" :class="{ open: isOpen }">
    <div v-down-outside="close" class="content">
      <header>Add Dropp</header>
      <form class="main" @submit="save">
        <div class="title">Dropp URL</div>
        <input ref="input" v-model="pin.url" type="text" class="b-input" />
        <div class="controls">
          <div class="cancel b-btn" @click="close">Cancel</div>
          <input
            class="confirm b-btn"
            type="submit"
            value="Save"
            @click="save"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';
import { ModalEvents } from 'app/utils/events';

export default {
  name: 'DropAddModal',
  components: {},
  directives: {
    downOutside,
  },
  data() {
    return {
      isOpen: false,
      pin: {
        url: '',
      }
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    ModalEvents.addListener('addDrop:open', this.open);
    ModalEvents.addListener('addDrop:close', this.close);
  },
  destroyed() {
    ModalEvents.removeListener('addDrop:open', this.open);
    ModalEvents.removeListener('addDrop:close', this.close);
  },
  methods: {
    open() {
      this.isOpen = true;
      setTimeout(() => {
        this.$refs.input.focus();
      }, 100);
    },
    close() {
      this.isOpen = false;
    },
    save(e) {
      e.preventDefault();
      if (!this.validate()) {
        return;
      }
      this.$store.dispatch('addTag', this.tag);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-drop-add-modal {
  
}
</style>
